import NutrientsModal from './NutrientsModal';
export default NutrientsModal;